// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ContentComponentItemFragmentDoc } from '../ContentComponentItem.fragment.generated';
export const FaqQuestionFragmentDoc = gql`
    fragment faqQuestion on FaqQuestion {
  question
  expandedByDefault
  content {
    ...contentComponentItem
  }
}
    ${ContentComponentItemFragmentDoc}`;